module.exports = __webpack_public_path__ + "img/gotoko.2b3c09a7.jpg";